"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveLocaleFromMarket = void 0;
var locales_1 = require("../locales");
/**
 * @param {string} market - Market id
 * @param {Locale[]} acceptedLocales - Accepted Locales
 * @returns {Locale} Locale
 */
function resolveLocaleFromMarket(market, acceptedLocales) {
    var locales = (acceptedLocales === null || acceptedLocales === void 0 ? void 0 : acceptedLocales.length) ? acceptedLocales : locales_1.LOCALES;
    var isValidLocale = function (maybeLocale) { return locales.includes(maybeLocale); };
    for (var _i = 0, locales_2 = locales; _i < locales_2.length; _i++) {
        var locale = locales_2[_i];
        if (!locales_1.LOCALES_SET.has(locale)) {
            throw new Error("Invalid locale: ".concat(locale));
        }
    }
    if (isValidLocale(market))
        return market;
    var current = market;
    while (current in locales_1.MARKET_LOCALE_MAP) {
        if (isValidLocale(current))
            return current;
        // TODO: Fix type issue
        current = locales_1.MARKET_LOCALE_MAP[current];
    }
    // TODO: Fix duplicate check?
    if (isValidLocale(current))
        return current;
    return (0, locales_1.getDefaultLocale)();
}
exports.resolveLocaleFromMarket = resolveLocaleFromMarket;
